import { Text } from '../../text/text.tsx'

export const PageHeaderOverlineDivider = ({
  className,
}: { className?: string }) => (
  <Text textColor="secondary" fontSize="sm" className={className}>
    |
  </Text>
)
